import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { InstallDialog, appInstalado, useAvisoTemporario } from "@/components/InstallApp";
import { X, Smartphone } from "lucide-react";

// Aviso da troca de domínio (iepplataformaead.online → iepplataforma.com). Some sozinho depois desta data.
const ATE = new Date("2026-11-26T00:00:00-03:00").getTime();
const CHAVE = "iep-aviso-endereco-visto";

/** Já viu o aviso do endereço o bastante (ou fechou, ou já usa o app): não mostra mais neste aparelho. */
export const enderecoJaVisto = () => {
  if (Date.now() > ATE || appInstalado()) return true;
  try { return localStorage.getItem(CHAVE) === "1" || Number(localStorage.getItem("iep-aviso-endereco-vezes") || 0) >= 3; } catch (e) { return false; }
};

/** Faixa "Nosso endereço mudou": some sozinha em 20 s, aparece no máximo 3 vezes por aparelho e nunca para quem já usa o app.
 * Fechar no X ou abrir "Como reinstalar" esconde de vez. */
export function AvisoEndereco() {
  const [open, setOpen] = useState(false);
  const [jaVisto] = useState(enderecoJaVisto);
  const [visivel, , nuncaMais] = useAvisoTemporario("iep-aviso-endereco", { segundos: 20, maxVezes: 3, ativo: !jaVisto });
  const [hidden, setHidden] = useState(false);
  if (jaVisto || hidden || (!visivel && !open)) return open ? <InstallDialog open={open} onOpenChange={setOpen} /> : null;
  const close = () => { setHidden(true); nuncaMais(); try { localStorage.setItem(CHAVE, "1"); } catch (e) {} };
  return (
    <>
      <div className="mx-4 mt-3 flex items-center gap-3 rounded-xl border border-green-300 bg-green-50 px-3 py-2.5" data-testid="aviso-endereco">
        <span className="text-xl" aria-hidden>🎉</span>
        <div className="flex-1 text-sm text-slate-700">
          <strong>Nosso endereço mudou: agora é <span className="text-[#1E9E2A]">iepplataforma.com</span></strong>
          <div className="text-xs text-slate-500">Salve nos favoritos. Usa o app no celular? Reinstale pelo endereço novo. Login, cursos e certificados continuam iguais.</div>
        </div>
        <Button size="sm" variant="outline" onClick={() => { setOpen(true); nuncaMais(); try { localStorage.setItem(CHAVE, "1"); } catch (e) {} }} className="border-green-300 text-[#1E9E2A]" data-testid="aviso-endereco-reinstalar"><Smartphone className="h-4 w-4 mr-1" /> Como reinstalar</Button>
        <button onClick={close} className="text-slate-400 hover:text-slate-600" aria-label="Fechar aviso" title="Fechar aviso"><X className="h-4 w-4" /></button>
      </div>
      <InstallDialog open={open} onOpenChange={setOpen} />
    </>
  );
}
